export var RewardManagerInstruction;
(function (RewardManagerInstruction) {
    RewardManagerInstruction[RewardManagerInstruction["Init"] = 0] = "Init";
    RewardManagerInstruction[RewardManagerInstruction["ChangeManagerAccount"] = 1] = "ChangeManagerAccount";
    RewardManagerInstruction[RewardManagerInstruction["CreateSender"] = 2] = "CreateSender";
    RewardManagerInstruction[RewardManagerInstruction["DeleteSender"] = 3] = "DeleteSender";
    RewardManagerInstruction[RewardManagerInstruction["CreateSenderPublic"] = 4] = "CreateSenderPublic";
    RewardManagerInstruction[RewardManagerInstruction["DeleteSenderPublic"] = 5] = "DeleteSenderPublic";
    RewardManagerInstruction[RewardManagerInstruction["SubmitAttestation"] = 6] = "SubmitAttestation";
    RewardManagerInstruction[RewardManagerInstruction["EvaluateAttestations"] = 7] = "EvaluateAttestations";
})(RewardManagerInstruction || (RewardManagerInstruction = {}));
/**
 * Custom error codes from the Reward Manager program
 * @see {@link https://github.com/AudiusProject/audius-protocol/blob/2a37bcff1bb1a82efdf187d1723b3457dc0dcb9b/solana-programs/reward-manager/program/src/error.rs solana-programs/reward-manager/program/src/errors.rs}
 */
export var RewardManagerErrorCode;
(function (RewardManagerErrorCode) {
    RewardManagerErrorCode[RewardManagerErrorCode["IncorrectOwner"] = 0] = "IncorrectOwner";
    RewardManagerErrorCode[RewardManagerErrorCode["SignCollision"] = 1] = "SignCollision";
    RewardManagerErrorCode[RewardManagerErrorCode["WrongSigner"] = 2] = "WrongSigner";
    RewardManagerErrorCode[RewardManagerErrorCode["NotEnoughSigners"] = 3] = "NotEnoughSigners";
    RewardManagerErrorCode[RewardManagerErrorCode["Secp256InstructionMissing"] = 4] = "Secp256InstructionMissing";
    RewardManagerErrorCode[RewardManagerErrorCode["InstructionLoadError"] = 5] = "InstructionLoadError";
    RewardManagerErrorCode[RewardManagerErrorCode["RepeatedSenders"] = 6] = "RepeatedSenders";
    RewardManagerErrorCode[RewardManagerErrorCode["SignatureVerificationFailed"] = 7] = "SignatureVerificationFailed";
    RewardManagerErrorCode[RewardManagerErrorCode["OperatorCollision"] = 8] = "OperatorCollision";
    RewardManagerErrorCode[RewardManagerErrorCode["AlreadySent"] = 9] = "AlreadySent";
    RewardManagerErrorCode[RewardManagerErrorCode["IncorrectMessages"] = 10] = "IncorrectMessages";
    RewardManagerErrorCode[RewardManagerErrorCode["MessagesOverflow"] = 11] = "MessagesOverflow";
    RewardManagerErrorCode[RewardManagerErrorCode["MathOverflow"] = 12] = "MathOverflow";
    RewardManagerErrorCode[RewardManagerErrorCode["InvalidRecipient"] = 13] = "InvalidRecipient";
})(RewardManagerErrorCode || (RewardManagerErrorCode = {}));
/**
 * The UI friendly error messages for each error code.
 * @see {@link https://github.com/AudiusProject/audius-protocol/blob/2a37bcff1bb1a82efdf187d1723b3457dc0dcb9b/solana-programs/reward-manager/program/src/error.rs solana-programs/reward-manager/program/src/errors.rs}
 */
export const RewardManagerErrorMessages = {
    [RewardManagerErrorCode.IncorrectOwner]: 'Input account owner is not the program address',
    [RewardManagerErrorCode.SignCollision]: 'Signature with an already met principal',
    [RewardManagerErrorCode.WrongSigner]: 'Unexpected signer met',
    [RewardManagerErrorCode.NotEnoughSigners]: "Isn't enough signers keys",
    [RewardManagerErrorCode.Secp256InstructionMissing]: 'Secp256 instruction missing',
    [RewardManagerErrorCode.InstructionLoadError]: 'Instruction load error',
    [RewardManagerErrorCode.RepeatedSenders]: 'Repeated sender',
    [RewardManagerErrorCode.SignatureVerificationFailed]: 'Signature verification failed',
    [RewardManagerErrorCode.OperatorCollision]: 'Some signers have same operators',
    [RewardManagerErrorCode.AlreadySent]: 'Funds already sent',
    [RewardManagerErrorCode.IncorrectMessages]: 'Incorrect messages',
    [RewardManagerErrorCode.MessagesOverflow]: 'Messages overflow',
    [RewardManagerErrorCode.MathOverflow]: 'Math overflow',
    [RewardManagerErrorCode.InvalidRecipient]: 'Invalid Recipient'
};
//# sourceMappingURL=constants.js.map